import React from 'react';

const Footer = () => {
    return (
        <div className="mt-5 p-1 text-white bg-secondary">
            <div className="">
                <div className="mb-0">
                    <p className="mb-0"> <strong>Address : </strong> অফিস: ২য় তলা ,শেখ সানাউল্লাহ জামে মসজিদ মার্কেট জিতু মিয়ার পয়েন্ট সিলেট ।</p>
                    <p className="mb-0"> <strong>Phone : </strong> +8801725 843030 , +8801842 823030 </p>
                    <p className="mb-0"> <strong>Email : </strong> tostourismbd@gmail.com</p>
                </div>
            </div>
            <div>
                <small> Copyright © 2021 Tourism Of Sylhet. All Rights Reserved</small>
            </div>
        </div>
    );
};
export default Footer;